<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C5nbJt/tc-custom/9781455603213.jpg?1726273345633" alt="This image is the cover for the book Cuisine Cajun"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cuisine Cajun
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A cookbook that captures the fresh ingredients, pungent spices, and creativity of Louisiana Cajun cooking—from Coush-Coush to Crab Jambalaya to Syrup Cake.</b></p> Cajun cooking is a melting pot of flavors. From gumbo simmered all afternoon on the stove, to Jambalaya aux Ecrive (Crawfish Jambalaya), to sweet pralines for dessert, the recipes of <i>La Cuisine Cajun </i>reflect the creative Cajun tradition. <i>La Cuisine Cajun</i> will have you cooking like a true Cajun—no matter what your ancestry! A complete cookbook, it contains recipes that are a pleasure to prepare, with clear instructions to guide every cook, from novices to gourmets. After each recipe, author Jude Theriot offers a bit of “lagniappe” (something extra)—tips about freezing, storing, and serving. A calorie count is also included for all recipes. While <i>La Cuisine Cajun</i> is not a “diet” cookbook, this unique feature is helpful for calorie watchers. Try Crawfish Bisque, Baked Trout Vermilion, Quick Turkey Jambalaya, Cajun French Fries, and Pain Perdu (Lost Bread or French toast), and you’ll begin to explore the possibilities <i>La Cuisine Cajun</i> has to offer. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jude Theriot
      </h2>
      
      <p class="authorDescription body article">Jude W. Theriot, CCP, is a nationally renowned chef with expertise in preparing Louisiana regional cuisines. He has traveled the country promoting Cajun cooking and conducted cooking-school classes. Theriot has been featured on television and radio and in magazines and newspapers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79e50e6c